export default __webpack_public_path__ + "static/media/Arrow.daa2f320.svg";